import styled from '@emotion/styled'
import { DESIGN_TOKENS } from 'constants/color.constants'

const StyledRequiredInputLabel = styled.span`
    color: ${DESIGN_TOKENS.text.accentForeground};
`

export const RequiredInputLabel = () => {
    return <StyledRequiredInputLabel> *</StyledRequiredInputLabel>
}
